module.exports = __webpack_public_path__ + "static/media/zwilling.90ff75f9.svg";